module.exports = __webpack_public_path__ + "img/budapest.daa10b44.jpg";